const undergrad = {
    title: "Computer Science",
    organization: "University at Buffalo, SUNY",
    location: "Buffalo, New York",
    web: "http://engineering.buffalo.edu/",
    date: "August 2016 - expected May 2020",
    details: ["Pursuing a B.S. in Computer Science",
        "Contributed as a UX/UI researcher and front-end developer to OneDataShare.",
        "2019-2020 Head Graphic Artist for the Student Association",
        "2019-2020 President & 2017-2018 Performance Cultural Chair of the Filipino American Student Association."]
};

const hs = {
    title: "Intensive Academic Humanities",
    organization: "Townsend Harris High School",
    location: "Queens, New York",
    web: "https://www.thhs.qc.edu/",
    date: "September 2012- May 2016",
    details: ["Graduated with an Advanced Honors Regents Diploma.",
        "Member of the ARISTA Honor Society",
        "Member of the ARCHON Honor Society",
        "Member of pit crew for the FRC2601: Steel Hawks.",
        "Member of the varsity wrestling, varsity badminton, and varsity bowling teams."]
};

export const education = [undergrad, hs];